import { Icon } from 'palette/Icon';
import { BodyText, Small } from 'palette/Typography';
import { BEMBlock } from '@helpers/classnames';
import type { RecentSearch } from '../types';
import GlobalSearchHeader from './GlobalSearchHeader';
import GlobalSearchResultsBlock from './GlobalSearchResultsBlock';
import GlobalSearchRow from './GlobalSearchRow';
import '../styles/GlobalSearchRecentSearches.scss';

interface GlobalSearchRecentSearchesProps {
    headerButtonLabel?: string;
    headerTitle: string;
    recentSearches: RecentSearch[];
    onRecentSearchClick: (id: string) => void;
    onDeleteAllClick: () => void;
}

function GlobalSearchRecentSearches({
    headerButtonLabel,
    headerTitle,
    recentSearches,
    onRecentSearchClick,
    onDeleteAllClick,
}: GlobalSearchRecentSearchesProps) {
    const [block, BEMElement] = BEMBlock('global-search-recent-searches');

    return (
        <div className={block}>
            <GlobalSearchResultsBlock>
                <GlobalSearchHeader
                    hasButton
                    buttonLabel={headerButtonLabel}
                    title={headerTitle}
                    onClick={onDeleteAllClick}
                />
                {recentSearches.map(({
                    token, url, title, subtitle,
                }) => (
                    <GlobalSearchRow
                        key={token}
                        href={url}
                        onClick={() => onRecentSearchClick(token)}
                    >
                        <div className={BEMElement('item')}>
                            <BodyText level="1">{title}</BodyText>
                            <Small color="light">{subtitle}</Small>
                        </div>
                        <Icon
                            className={BEMElement('icon')}
                            color="grey-800"
                            name="palette_chevron_right"
                            size="small"
                        />
                    </GlobalSearchRow>
                ))}
            </GlobalSearchResultsBlock>
        </div>
    );
}

export default GlobalSearchRecentSearches;
